var rich_content_viewer_default = {
  "fontElementMap": "_7lin0",
  "wrapper": "iahK5",
  "pluginContainerMobile": "qBrlE",
  "viewer": "EkN81",
  "android": "GpoT-",
  "rootedTraversedContent": "XH-4M",
  "atomic": "uyFNq",
  "toolbar": "w-uxS",
  "block": "FU-8X"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
